<template>
  <div class="form-container editform-container">
    <h1><span>防獣害対策</span>
	<span class="color">
		（{{ typeMapping[editableData.type] }}）
	</span>
	</h1>
    <form>
      <table class="wildlife-list-edit-table">
        <tbody>
          <tr>
            <td class="title">受付番号</td>
            <td>：<input type="text" id="no" disabled
				:value="editableData.no" /></td>
          </tr>
          <tr>
            <td class="title">利用者</td>
            <td>：<input itype="text" id="id" disabled
            	:value="editableData.id + ' ' + editableData.nameKanji" />
			</td>
          </tr>
        </tbody>

        <tbody v-if="isTrapType">
          <tr>
            <td class="title">設置場所</td>
            <td>：<input type="text" id="municipalities"
                v-model="editableData.municipalities"
                placeholder="都道府県市区町村" />
            </td>
          </tr>
          <tr>
            <td class="title"></td>
            <td>　<input type="text" id="strAdd"
                v-model="editableData.strAdd"
                placeholder="地区" />
            </td>
          </tr>
		  <tr>
            <td class="title">日時</td>
            <td>：
			<input type="datetime-local" id="damageDate"
				v-model="editableData.damageDate" />
            <span v-if="errors.damageDate" class="error-message">
				{{ errors.damageDate }}</span>
            </td>
          </tr>
          <tr>
            <td class="title">獣種</td>
            <td>：
              <select id="animalType" v-model="editableData.animalType">
              <option disabled value="">選択してください</option>
              <option v-for="type in animalTypes"
				:key="type.value" :value="type.value">
				{{ type.label }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="title">わなの種類</td>
            <td>：
              <select id="trapType" v-model="editableData.trapType">
                <option disabled value="">選択してください</option>
                <option v-for="type in trapTypes"
					:key="type.value" :value="type.value">
					{{ type.label }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="title">わなの幅（cm）</td>
            <td>：<input type="text" id="trapWidth"
				v-model="editableData.trapWidth" />
            <span v-if="errors.trapWidth" class="error-message">
				{{ errors.trapWidth }}</span>            
            </td>
          </tr>
          <tr>
            <td class="title">わなの高さ(cm)</td>
            <td>：<input type="text" id="trapHeight"
				v-model="editableData.trapHeight" />
            <span v-if="errors.trapHeight" class="error-message">
				{{ errors.trapHeight }}</span>
            </td>
          </tr>
          <tr>
            <td class="title">わなの奥行（cm）</td>
            <td>：<input type="text" id="trapDepth"
				v-model="editableData.trapDepth" />
            <span v-if="errors.trapDepth" class="error-message">
				{{ errors.trapDepth }}</span>
            </td>
          </tr>
        </tbody>

        <tbody v-if="isFenceType">
          <tr v-if="isFenceType">
            <td class="title">名称</td>
            <td>：<input type="text" id="fenceName"
                v-model="editableData.fenceName"
                placeholder="名称" />
            </td>
          </tr>
          <tr>
            <td class="title">日付</td>
            <td>：
			<input type="date" id="fenceInstDate"
				v-model="editableData.fenceInstDate" />
            <span v-if="errors.damageDate" class="error-message">
				{{ errors.damageDate }}</span>
            </td>
          </tr>
          <tr>
            <td class="title"></td>
            <td>～
			<input type="date" id="fenceRemoDate"
				v-model="editableData.fenceRemoDate" />
            <span v-if="errors.damageDate" class="error-message">
				{{ errors.damageDate }}</span>
            </td>
          </tr>
          <tr>
            <td class="title">柵の種類</td>
            <td>：
              <select id="fenceType" v-model="editableData.fenceType">
                <option disabled value="">選択してください</option>
                <option v-for="type in fenceTypes"
					:key="type.value" :value="type.value">
					{{ type.label }}</option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="title">柵の総延長(km)</td>
            <td>：<input type="text" id="fenceLength"
				v-model="editableData.fenceLength" />
            <span v-if="errors.fenceLength" class="error-message">
				{{ errors.fenceLength }}</span>            
            </td>
          </tr>
        </tbody>

        <tbody>
          <!-- 画像 -->
          <tr>
            <td class="title">画像</td>
              <td>：
                <img :src="editableData.imageUrl" class="thumb"
				@click="imageUp(editableData.imageUrl)" />
				　
                <img :src="editableData.imageUrl1" class="thumb"
				@click="imageUp(editableData.imageUrl1)" />
				　
                <img :src="editableData.imageUrl2" class="thumb"
				@click="imageUp(editableData.imageUrl2)" />
              </td>
          </tr>

		  <tr v-if="isTrapType">
            <td class="title">備考</td>
            <td>：
				<textarea id="addNote" v-model="editableData.addNote">
				</textarea>
            <span v-if="errors.addNote" class="error-message">
				{{ errors.addNote }}</span>
            </td>
          </tr>
		  <tr v-else>
            <td class="title">追記事項</td>
            <td>：
				<textarea id="addNote" v-model="editableData.fencememo"
				></textarea>
            <span v-if="errors.addNote" class="error-message">
				{{ errors.addNote }}</span>
            </td>
          </tr>

          <tr>
            <td class="title">緯度</td>
            <td>：
              <input type="text" id="location-latitude" placeholder="緯度"
                v-model="editableData.locationLat" />
			</td>
		  </tr>
		  <tr>
            <td class="title">経度</td>
			<td>　
              <input type="text" id="location-longitude" placeholder="経度"
                v-model="editableData.locationLon" />
            </td>
          </tr>
        </tbody>
      </table>
    </form>

    <div class="edit-button-group">
      <button type="button" @click="cancelEdit" class="second">キャンセル</button>
      <button type="submit" @click="validateAndSaveChanges" class="alert">更新</button>
    </div>
  </div>
	<!-- ポップアップ -->
	<div class="popup" v-if="popup_on">
    	<img :src="popup_src" @click="imageDown" class="big" />
    </div>
</template>

<script>
import "@/assets/styles/Wildlife-edit-table.css";
import axios from "axios";
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  data() {
    return {
      editableData: {},
      isTrapType: false,
      isFenceType: false,
	  popup_on: false,
	  popup_src: '',
      errors: {}, // エラーオブジェクトを追加
      typeMapping: {
        "5": "わな",
        "6": "柵",
      },
      animalTypes: [
        { value: "01", label: "イノシシ"},
        { value: "02", label: "ニホンジカ"}, 
        { value: "03", label: "クマ"}, 
        { value: "04", label: "サル"}, 
        { value: "05", label: "タヌキ"}, 
        { value: "06", label: "アナグマ"}, 
        { value: "07", label: "ハクビシン"}, 
        { value: "08", label: "アライグマ"}, 
        { value: "09", label: "ヌートリア"}, 
        { value: "10", label: "鳥類"}, 
        { value: "11", label: "その他"}
      ],
      // headCounts: ["1", "2", "3", "4", "5以上", "不明"],
      juvenileTypes: [
        { value: "2", label: "幼獣"}, 
        { value: "1", label: "成獣"}, 
        { value: "3", label: "幼獣と成獣"}, 
        { value: "4", label: "不明"}
      ],
      // genders: ["オス", "メス", "オスとメス", "不明"],
      trapTypes: [
        { value: "1", label: "箱わな" },
        { value: "2", label: "囲いわな" },
        { value: "3", label: "くくりわな" },
        { value: "4", label: "箱落とし" },
        { value: "5", label: "その他" }
      ],
      fenceTypes: [
        { value: "1", label: "電気" },
        { value: "2", label: "金属" },
        { value: "3", label: "ネット" },
        { value: "4", label: "ワイヤーメッシュ" },
        //{ value: "5", label: "複合" },
        { value: "9", label: "その他" },
      ],
    };
  },
  created() {
	try {
      if (this.$route.query.data)
        this.editableData =
      		JSON.parse(decodeURIComponent(this.$route.query.data));
	} catch(e) {
		alert(e);
	}
    this.isTrapType = this.editableData.type === "5";
    this.isFenceType = this.editableData.type === "6";
  },
  mounted() {
	try {
    // 初期値を結合して設定
    if (this.editableData.damageDate) {
      const date = new Date(this.editableData.damageDate);
      date.setTime(date.getTime() + 9 * 60 * 60 * 1000); // 日本時間に調整（9時間をミリ秒で加算）

      // datetime-local用にフォーマット (YYYY-MM-DDTHH:MM)
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      this.editableData.damageDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    }
    if (this.editableData.fenceInstDate) {
      const date = new Date(this.editableData.fenceInstDate);
      date.setTime(date.getTime() + 9 * 60 * 60 * 1000); // 日本時間に調整（9時間をミリ秒で加算）
      this.editableData.fenceInstDate = date.toISOString().split("T")[0]; // YYYY-MM-DD形式に変換
    }
    if (this.editableData.fenceRemoDate) {
      const date = new Date(this.editableData.fenceRemoDate);
      date.setTime(date.getTime() + 9 * 60 * 60 * 1000); // 日本時間に調整（9時間をミリ秒で加算）
      this.editableData.fenceRemoDate = date.toISOString().split("T")[0]; // YYYY-MM-DD形式に変換
    }

	} catch (e) {
		alert(e);
	}
  },
  methods: {
	imageDown() {
		this.popup_on = false;
	},
	imageUp(src) {
		if (this.popup_src != src) {
			this.popup_src = src;
			this.popup_on = true;
		} else {
			this.popup_on = !this.popup_on;
		}
	},
    validateForm() {
      const errors = {};
      // 必須項目のエラーチェック
      if (this.isFenceType && !this.editableData.fenceLength) errors.fenceLength = "柵の総延長(km)は必須です";
      console.log("被害日時"+this.editableData.damageDate);
      if (this.editableData.type === '5' && !this.editableData.damageDate) {
        errors.damageDate = "日時は必須です";
      }
      if (this.editableData.type === '6' && !this.editableData.fenceInstDate) {
        errors.damageDate = "日時は必須です";
      }
      
      // 桁数とバリデーションチェック
      // わなの幅（cm）
      if (this.editableData.trapWidth && !/^(\d{1,13}(\.\d{1,2})?)$/.test(this.editableData.trapWidth)) {
        errors.trapWidth = "わなの幅（cm）は整数部13桁、小数部2桁までで入力してください";
      }
      // わなの高さ(cm)
      if (this.editableData.trapHeight && !/^(\d{1,13}(\.\d{1,2})?)$/.test(this.editableData.trapHeight)) {
        errors.trapHeight = "わなの高さ(cm)は整数部13桁、小数部2桁までで入力してください";
      }
      // わなの奥行（cm）
      if (this.editableData.trapDepth && !/^(\d{1,13}(\.\d{1,2})?)$/.test(this.editableData.trapDepth)) {
        errors.trapDepth = "わなの奥行（cm）は整数部13桁、小数部2桁までで入力してください";
      }
      // 柵の総延長(km)
      if (this.editableData.fenceLength && !/^\d*(\.\d{1,2})?$/.test(this.editableData.fenceLength)) {
        errors.fenceLength = "柵の総延長(km)は小数部2桁までで入力してください";
      }
      // 備考
      if (this.editableData.addNote && this.editableData.addNote.length > 1000) {
        errors.addNote = "備考は1000桁以内で入力してください";
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },
    validateAndSaveChanges() {
      if (this.validateForm()) {
        this.saveChanges().then( ()=> {
          //this.$router.push({ name : 'MeasureList' });
		});
      } else {
        // バリデーションエラーがある場合にポップアップで警告を表示
        alert('入力エラーがあります');
      }
    },
    async saveChanges() {
      let storedAdmins = JSON.parse(localStorage.getItem('adminAgencies')) || [];
      storedAdmins.push(this.newAdmin);
      localStorage.setItem('adminAgencies', JSON.stringify(storedAdmins));

      // JWTトークンを取得
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      // datetime-localの値を取得
      const inputDateTime = this.editableData.damageDate;
      // Dateオブジェクトとして作成（ローカルタイムとして解釈される）
      const localDate = new Date(inputDateTime);
      // ISO形式に変換してフロントエンドから送信
      const adjustedDateTime = localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"形式に調整

      try {
        // サーバーに送信するデータをJSONに加工
        const dataToSubmit = {
          region_Id: this.editableData.region_Id || null,
          no: this.editableData.no || null,
          id: this.editableData.id || null,
          type: this.editableData.type || null,
          trapType: this.editableData.trapType || null,
          trapWidth: this.editableData.trapWidth || null,
          trapHeight: this.editableData.trapHeight || null,
          trapDepth: this.editableData.trapDepth || null,
          fenceType: this.editableData.fenceType || null,
          fenceLength: this.editableData.fenceLength || null,
          animalType: this.editableData.animalType || null,
          byAnimal: this.editableData.byAnimal || null,
          damageDate: adjustedDateTime || null,
          addNote: this.editableData.addNote || null,
          locationLat: this.editableData.locationLat || null,
          locationLon: this.editableData.locationLon || null,
          modifierId: userId || null,
          modifyDate: null,
		// R.K
          fenceInstDate: this.editableData.fenceInstDate || null,
          fenceRemoDate: this.editableData.fenceRemoDate || null,
          fenceName: this.editableData.fenceName || null,
          fencememo: this.editableData.fencememo || null,
          municipalities: this.editableData.municipalities || null,
          strAdd: this.editableData.strAdd || null,
        };

        for (const [key, value] of Object.entries(dataToSubmit)) {
          if (value === undefined) {
            dataToSubmit[key] = "";  // undefinedの場合は空文字に設定
          }
        }

        // APIリクエスト送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/wildlifeCounterPlan/update`,
          dataToSubmit,
          {
            headers: {
              Authorization: `Bearer ${token}`, // JWTトークンを送信
            },
          }
        );

        // ステータスコード200の場合（送信成功）
        if (response.status === 200) {
          // 新しいトークンがレスポンスヘッダーに含まれている場合
          const newToken = response.headers.get('Authorization');
          if (newToken) {
              localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
          }
          console.log("送信成功", response.data);
          alert("データが正常に登録されました");
        } else {
			alert("不明なエラーです")
		}
        this.$router.push({ name : 'MeasureList' });
      } catch (error) {
//alert(error.response.data.message)
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
      //this.$router.go(-1);
    },
    cancelEdit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
.title { font-weight: bold; }
.color { color: green; }
.thumb { max-width: 100px; cursor: zoom-in; }
.big { max-width: 300px; cursor: zoom-out; }
.popup {
  width:600px;
  height:auto;
  display: block;
  position: fixed;
  top: 15%;
  left: 70%;
  transform:translate(-50%);
  text-align: right;
}
</style>
